import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { setReorderOrderId } from '../../../core/state/order/orderActions';
import { getOrderHistory } from '../../../core/state/order/orderMiddleware';
import { user } from '../../../core/state/user';
import { RestaurantMenu } from '../../../pages/RestaurantMenu';
import { getDeliveryLocation } from '../../../pages/RestaurantMenu/utils/locationHeaderUtils';
import * as Actions from '../../actions/Actions';
import * as BasketControl from '../../BasketControl';
import { basketSelectors } from '../../redux';
import { setBasket } from '../../redux/basket/actions';
import { RouteParams } from '../../Routes';
import * as Store from '../../Store';

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: Store.State, ownProps: RouteParams) => {
  const { flipdish } = state;
  const { params } = ownProps;

  return {
    appConfig: flipdish.AppConfig,
    basket: basketSelectors.getBasketBridge(state),
    collectionDetails: state.collectionRestaurants,
    collectionSummaries: flipdish.CollectionSummaries,
    customer: flipdish.Customer,
    deliveryLocation: getDeliveryLocation(flipdish.DeliveryLocations, params),
    deliveryDetails: state.deliveryRestaurants,
    deliverySummaries: flipdish.DeliverySummaries,
    expandedState: flipdish.ExpandedStates[params.vrid],
    isLoggedIn: user.selectors.isLoggedIn(state),
    languages: state.locale.languages,
    menus: flipdish.MenuData,
    previousOrders: state.orders.history,
    translate: getTranslate(state.locale) as any,
    urlLocation: ownProps.location,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => ({
  actions: {
    getLocationAreaData: (prId: number): void => {
      dispatch(Actions.getLocationAreaData(prId));
    },
    getOrderHistory: (): void => {
      dispatch(getOrderHistory(50));
    },
    getMenuByUrl: (menuUrl: string): void => {
      dispatch(Actions.getMenuByUrl(menuUrl));
    },
    getRestaurantDetail: (
      vrId: number,
      orderType: string,
      id: number,
    ): void => {
      dispatch(Actions.getRestaurantData(vrId, orderType, id));
    },
    getRestaurantSummaries: (): void => {
      dispatch(Actions.FindInitialRestaurant());
    },
    setBasket: (payload: WebOrder.State.Basket): void => {
      dispatch(setBasket(payload));
    },
    setReorderOrderId: (orderId: number): void => {
      dispatch(setReorderOrderId(orderId));
    },
  },

  InitializeExpandedState: (vrid: number, expandedState: number[]) => {
    dispatch(Actions.InitializeExpandedState(vrid, expandedState));
  },
  PushLoginUrl: (url: string) => {
    dispatch(Actions.PushAfterLogin(url));
  },
  SetRestaurantUrl: () => {
    dispatch(Actions.SetRestaurantUrl(window.location.hash.substr(1)));
  },
  AddItemToBasket: (payload: BasketControl.Item) => {
    dispatch(Actions.AddToBasket(payload));
  },
  RemoveItemFromBasket: (payload: {
    menuId: number;
    index: number;
    indexName?: string;
  }) => {
    dispatch(Actions.RemoveFromBasket(payload));
  },
  EditTableNumber: (vrid: number, locationId: number) => {
    dispatch(Actions.EditTableNumbers(vrid, locationId));
  },
  AddToExpandedState: (vrid: number, menuSectionId: number) => {
    dispatch(Actions.AddToExpandedState(vrid, menuSectionId));
  },
  RemoveFromExpandedState: (vrid: number, menuSectionId: number) => {
    dispatch(Actions.RemoveFromExpandedState(vrid, menuSectionId));
  },
  setTableLock: (prid: number, isEnabled: boolean) => {
    dispatch(Actions.SetTableLock(prid, isEnabled));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantMenu);
